<template>
    <div class="sipContent" id="sip"> 
        <div class="call-modal">
            <div class="time-info-box row">
                <div class="col-md-10">
                    Gelen Arama
                </div>
                <div class="col-md-2">
                    00:00:00
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"sipClient",
    props:['incomingCall'],
    data() {
        return {
           
        }
    },
    methods: {
      
    },
}
</script>
<style scoped>
    @import url('https://fonts.googleapis.com/icon?family=Material+Icons');

    .sipContent{
        margin: 0;
        padding: 0;
    }
    .call-modal {
        padding: 0;
        width: 840px;
        height: 150px;
        background: #333333;
        margin: auto;
    }
    .time-info-box {
        padding: 8px;
        margin: 0;
        background: #03B800;
    }
</style>